module.exports = __webpack_public_path__ + "img/members_to_chart.400dcfb9.png";